module.exports = __webpack_public_path__ + "img/stop-circle-fill.4f6c52ed.svg";